import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Filter } from '../../models/filter.models';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'filters',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
) {
  }

  formGroup: FormGroup;
  public filterSelected: any = null;
  public selectedFilters: any[] = [];
  public filtersList: any[] = [];

  @Input() filters: any[] = [];

  @Output() queryParamFilter: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.filtersList = Object.assign([], this.filters)
    this.createForm();
  }
  createForm() {
    this.formGroup = this.formBuilder.group({});
  }

  accept() {
    let queryParam = this.formGroup.value;
    for (let key of Object.keys(queryParam)) {
      if (queryParam[key] == null)
      {
        delete queryParam[key];
      }
      if (typeof queryParam[key] === 'object' )
      {
        queryParam[key] =  this.datePipe.transform(queryParam[key],'yyyy-MM-dd');
      }
    }
    this.queryParamFilter.emit(queryParam)
  }

  addFilter() {
    let index = this.filtersList.findIndex((e) => e.name === this.filterSelected);
    this.selectedFilters.push(this.filtersList[index]);
    this.addControl(this.filtersList[index]);
    this.filtersList.splice(index, 1);
  }

  deleteFilter(name: string) {
    let index = this.selectedFilters.findIndex((e) => e.name === name);
    this.filtersList.push(this.selectedFilters[index]);
    this.deleteControl(this.selectedFilters[index]);
    this.selectedFilters.splice(index, 1);
    this.filterSelected = null;
  }

  private addControl(filter: Filter) {

    if (filter.type === 'date_range' || filter.type === 'number_range') {
      this.formGroup.addControl(filter.options.from.key, this.formBuilder.control('', []));
      this.formGroup.addControl(filter.options.to.key, this.formBuilder.control('', []));
    } else {
      this.formGroup.addControl(filter.options.key, this.formBuilder.control('', []));
    }
  }

  private deleteControl(filter: Filter) {
    if (filter.type === 'date_range' || filter.type === 'number_range') {
      this.formGroup.removeControl(filter.options.from.key);
      this.formGroup.removeControl(filter.options.to.key);
    } else {
      this.formGroup.removeControl(filter.options.key);
    }
  }
}
